import { __extends } from "tslib";
import { fetchVideo, fetchVideos } from '@gn-audio/core/api/knowledge-base';
import { GroupRestrictedSpotType } from 'src/Shared/enums/group-restricted-spot-type.enum';
import { ContactSupportSectionController } from 'src/Feature/ContactSupport/app';
import { generateVideoPath } from '../utils/generate-video-path';
import { generateVideoUrl } from '../utils/generate-video-url';
import { videoEvaluator } from '../utils/video-evaluator';
var VideoSpotController = (function (_super) {
    __extends(VideoSpotController, _super);
    function VideoSpotController($rootScope, $scope, $q, productContextService, videoContextService, dynamicPagesSpotsDisplayOptionsService) {
        var _this = _super.call(this, $scope, productContextService, dynamicPagesSpotsDisplayOptionsService, GroupRestrictedSpotType.Other) || this;
        _this.$rootScope = $rootScope;
        _this.$scope = $scope;
        _this.$q = $q;
        _this.videoContextService = videoContextService;
        return _this;
    }
    VideoSpotController.prototype.$onInit = function () {
        var _this = this;
        _super.prototype.$onInit.call(this);
        this.$scope.hasRelatedVideos = function () {
            return Array.isArray(_this.$scope.videos) && _this.$scope.videos.length > 0;
        };
        this.$scope.getVideoUrl = function (video) {
            return _this.$scope.group ? generateVideoUrl(_this.$scope.group, video === null || video === void 0 ? void 0 : video.id, true) : '';
        };
        this.$scope.getVideoPath = function (video) {
            return generateVideoPath(video);
        };
        this.productContextService
            .subscribe()
            .then(null, null, function (group) {
            _this.$scope.group = group;
            if (!_this.$scope.group) {
                return;
            }
            _this.$q.when(fetchVideo(_this.$scope.group.groupId, _this.getVideoCode()))
                .then(function (video) { _this.$scope.video = video; })
                .then(function () {
                if (!_this.$scope.video) {
                    return;
                }
                _this.videoContextService.setContext(_this.$scope.video);
                _this.$rootScope.$broadcast('related-faqs', _this.$scope.video.relatedFrequentlyAskedQuestions);
                if (!_this.$scope.group) {
                    return;
                }
                _this.$q.when(fetchVideos(_this.$scope.group.groupId))
                    .then(function (videos) {
                    _this.$scope.videos = (videos || [])
                        .filter(videoEvaluator)
                        .filter(function (v) { var _a; return v.code !== ((_a = _this.$scope.video) === null || _a === void 0 ? void 0 : _a.code); });
                });
            });
        });
    };
    VideoSpotController.prototype.getVideoCode = function () {
        var pathNames = location.pathname.split('/');
        return pathNames[pathNames.length - 1];
    };
    VideoSpotController.$inject = [
        '$rootScope',
        '$scope',
        '$q',
        'productContextService',
        'videoContextService',
        'dynamicPagesSpotsDisplayOptionsService',
    ];
    return VideoSpotController;
}(ContactSupportSectionController));
export { VideoSpotController };
